<template>
  <div id="coupon">
    <div v-if="!showDetail">
      <div class="tabbar">
        <div
          :class="item === currentChoose ? 'isAcitve' : ''"
          v-for="(item, index) in currentTabbar"
          :key="index"
          @click="clickItem(item, index)"
        >
          {{ item }}
        </div>
        <span class="view-dead-coupon">
          <span @click="tabBtn" class="jump">{{ tabBtnText }} ></span>
        </span>
      </div>
      <div class="coupon_list" v-if="totalCount !== 0">
        <div class="content">
          <div
            :class="['coupon_list_item', isValid ? '' : 'coupon_list_item--invalid']"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="left">
              <span class="amount"
                ><span class="icon">¥</span>{{ item.amount }}</span
              >
              <span class="limit">满{{ item.threshold }}元可用</span>
            </div>
            <div class="middle">
              <span class="name">{{ item.coupon_name }}</span>
              <span class="time">{{ item.validate_stop_time }} 到期</span>
              <span class="use-range">
                {{ item.use_range }}
                <span
                  @mouseenter="showInstructions(item)"
                  @mouseleave="chooseId = ''"
                  class="instructions"
                >
                  使用说明
                  <img
                    src="@/assets/image/Coupon/blackArrow.png"
                    alt=""
                  />
                  <span class="dialog" v-if="item.id == chooseId">
                    <h3>使用说明：</h3>
                    {{ item.coupon_desc }}
                  </span>
                </span>
              </span>
            </div>
            <div class="right" @click="useNow(item)">
              <span v-if="isValid" class="use-now">立即使用</span>
              <span
                v-else
                :class="[
                  'has-use',
                  currentChooseInvalid == '已使用' ? 'used' : 'expired'
                ]"
              ></span>
            </div>
          </div>
        </div>
        <div class="pages" v-if="totalCount > 10">
          <common-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pages"
            :page-size="PageSize"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </common-pagination>
        </div>
        <div></div>
      </div>
      <div class="coupon_list no_data" v-else>
        <empty-state
          :title="isValid ? '暂无可用优惠券' : '暂无失效优惠券'"
          description="优惠券会根据状态和类型自动归类展示"
          icon="el-icon-tickets"
          :icon-size="52">
        </empty-state>
      </div>
    </div>
  </div>
</template>
<script>
import { couponList } from "@/request/API";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: "",
  props: {},
  components: {
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      chooseId: "",
      showDetail: false,
      totalCount: 0,
      PageSize: 10,
      isValid: true,
      currentChooseInvalid: "已使用",
      currentChooseValid: "商品优惠券",
      tabbarItemValid: ["商品优惠券", "包赔优惠券", "诚心卖优惠券"],
      tabbarItemInvalid: ["已使用", "已过期"],
      tableData: [],
      pages: 1,
      coupon_type: 1,
      assess_price: "",
      product_id: "",
      game_id: ""
    };
  },
  methods: {
    clickItem(item, index) {
      this.pages = 1;
      if (this.isValid) {
        this.currentChooseValid = item;
      } else {
        this.currentChooseInvalid = item;
      }
      this.getData();
    },
    useNow(item) {
      if (this.isValid) {
        if (this.currentChoose == "诚心卖优惠券") {
          if (item.use_range == "全部游戏账号可用") {
            this.$router.push({ name: "AccountSell", params: {} });
          } else {
            this.$router.push({
              name: "AccountSell",
              params: { coupon: true, coupon_id: item.coupon_id }
            });
          }
        } else {
          if (item.use_range == "全部游戏账号可用") {
            this.$router.push({ name: "AllGame", params: {} });
          } else {
            this.$router.push({
              name: "AllGame",
              params: { coupon: true, coupon_id: item.coupon_id }
            });
          }
        }
      }
    },
    //分页监听事件
    handleCurrentChange(val) {
      console.log(val, "pageee");
      this.getData();
    },
    tabBtn() {
      this.pages = 1;
      this.isValid = !this.isValid;
      this.getData();
    },
    showInstructions(item) {
      if (this.isValid) {
        this.chooseId = item.id;
      }
    },
    getData() {
      this.tableData = [];
      let params = { pageSize: 10, page: this.pages, status: 0 };
      if (this.isValid) {
        params.status = 0;
        switch (this.currentChoose) {
          case "商品优惠券":
            params.coupon_type = 1;
            break;
          case "包赔优惠券":
            params.coupon_type = 2;
            break;
          case "诚心卖优惠券":
            params.coupon_type = 3;
            break;
          default:
            break;
        }
      } else {
        params.status = this.currentChooseInvalid == "已使用" ? 1 : 2;
      }
      couponList(params).then(res => {
        this.tableData = res.data.list.map(item => {
          switch (item.use_range) {
            case 1:
              item.use_range = "全部游戏账号可用";
              break;
            case 2:
              item.use_range = "部分游戏账号可用";
              break;
            case 3:
              item.use_range = "部分账号商品可用";
              break;
            default:
              break;
          }
          item.amount = Number(item.amount).toFixed(0);
          item.threshold = Number(item.threshold).toFixed(0);
          return item;
        });
        this.totalCount = res.data.total; //tab切换后的数据并不是接口请求回来的总数
      });
    }
  },
  mounted() {
    this.getData();
  },
  watch: {},
  computed: {
    currentTabbar() {
      return this.isValid ? this.tabbarItemValid : this.tabbarItemInvalid;
    },
    tabBtnText() {
      return this.isValid ? "查看失效券" : "返回";
    },
    currentChoose() {
      return this.isValid ? this.currentChooseValid : this.currentChooseInvalid;
    }
  }
};
</script>
<style lang="less">
#per_center .main:has(#coupon) {
  overflow: visible;
}
</style>
<style lang="less" scoped>
#coupon {
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin: 0 0 18px;
    padding: 4px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    div {
      height: 34px;
      padding: 0 16px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      user-select: none;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;

      &:hover {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }
    }

    .isAcitve {
      position: relative;
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      font-weight: 500;

      &:hover {
        color: #FFFFFF;
        background: var(--bg-dark, #1A1D24);
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      }
    }

    .view-dead-coupon {
      flex: 1;
      min-width: 120px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-main, #1A1D24);
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .jump {
        height: 34px;
        padding: 0 14px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        background: var(--bg-tag, #F0EDE8);
        cursor: pointer;
        user-select: none;
        transition: color .2s ease, background .2s ease;

        &:hover {
          color: #FFFFFF;
          background: var(--bg-dark, #1A1D24);
        }
      }
    }
  }

  .coupon_list {
    min-height: 620px;
    padding: 16px;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    .content {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;

      .coupon_list_item {
        min-width: 0;
        min-height: 132px;
        border-radius: 4px;
        display: flex;
        border: 1px solid rgba(255, 90, 31, 0.18);
        background: linear-gradient(90deg, var(--primary-soft, #FCEDE5) 0, #FFFFFF 128px, #FFFFFF 100%);
        box-shadow: 0 8px 24px rgba(255, 122, 26, 0.08);
        justify-content: space-between;
        align-items: center;
        position: relative;
        overflow: visible;
        transition: border-color .2s ease, box-shadow .2s ease;

        &:hover {
          border-color: rgba(255, 90, 31, 0.38);
          box-shadow: 0 12px 28px rgba(255, 90, 31, 0.14);
          z-index: 20;
        }

        &::before {
          width: 4px;
          align-self: stretch;
          border-radius: 4px 0 0 4px;
          background: var(--primary, #FF5A1F);
          content: "";
        }

        &--invalid {
          background: var(--bg-tag, #F0EDE8);
          border-color: var(--border-soft, #E8E4DE);
          box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

          &::before {
            background: var(--border-strong, #D8D2CA);
          }

          .left .amount,
          .middle .name {
            color: var(--text-muted, #9AA0AC);
          }

          .middle .instructions {
            color: var(--text-muted, #9AA0AC);
          }

          .left {
            border-right-color: var(--border-soft, #E8E4DE);
          }

          &:hover {
            border-color: var(--border-strong, #CBD5E1);
            box-shadow: 0 12px 28px rgba(26, 29, 36, 0.1);
          }
        }

        .left {
          flex: 0 0 112px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 100px;
          padding: 0 18px;
          border-right: 1px dashed rgba(255, 122, 26, 0.26);

          .amount {
            max-width: 100%;
            font-size: 32px;
            color: var(--primary, #FF7A1A);
            font-weight: 600;
            line-height: 38px;
            white-space: nowrap;

            .icon {
              margin-right: 2px;
              font-size: 14px;
              font-weight: 500;
            }
          }

          .limit {
            max-width: 100%;
            margin-top: 4px;
            color: var(--text-muted, #9AA0AC);
            font-size: 12px;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .middle {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 18px 14px 18px 18px;

          .name {
            width: 100%;
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .time {
            padding: 8px 0;
            font-size: 12px;
            color: var(--text-secondary, #5A5F6B);
            font-weight: 400;
            line-height: 18px;
          }

          .use-range {
            max-width: 100%;
            display: flex;
            align-items: center;
            color: var(--text-muted, #9AA0AC);
            font-size: 12px;
            line-height: 18px;

            .instructions {
              flex: 0 0 auto;
              color: var(--primary, #FF7A1A);
              margin-left: 12px;
              user-select: none;
              position: relative;
              display: inline-flex;
              align-items: center;
              cursor: default;
              z-index: 30;

              &::after {
                position: absolute;
                top: 18px;
                left: 0;
                width: 280px;
                height: 12px;
                content: "";
              }

              img {
                width: 8px;
                margin-left: 4px;
                opacity: .45;
              }

              .dialog {
                h3 {
                  margin: 0 0 6px 0;
                  font-size: 14px;
                  line-height: 20px;
                  color: var(--primary, #FF7A1A);
                }

                position: absolute;
                background: var(--bg-card, #FFFFFF);
                z-index: 60;
                top: 24px;
                left: 0;
                border-radius: 4px;
                padding: 12px 14px;
                width: 280px;
                border: 1px solid rgba(255, 90, 31, 0.18);
                box-shadow: 0 12px 28px rgba(255, 90, 31, 0.14);
                color: var(--text-secondary, #5A5F6B);
                font-size: 13px;
                font-weight: 400;
                line-height: 21px;
              }
            }
          }
        }

        .right {
          flex: 0 0 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 100px;
          padding-right: 18px;

          .use-now {
            min-width: 76px;
            height: 32px;
            border-radius: 4px;
            border: none;
            background: var(--primary-soft, #FCEDE5);
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            color: var(--primary, #FF5A1F);
            line-height: 32px;
            text-align: center;
            cursor: pointer;
            user-select: none;
            transition: color .2s ease, background .2s ease, box-shadow .2s ease;

            &:hover {
              color: #FFFFFF;
              background: var(--primary, #FF5A1F);
              box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
            }
          }

          .has-use {
            width: 76px;
            height: 64px;
            opacity: .75;
          }

          .used {
            background: url("../../../assets/image/Coupon/hasUse.png");
            background-size: cover;
          }

          .expired {
            background: url("../../../assets/image/Coupon/expired.png");
            background-size: cover;
          }
        }
      }
    }

    .pages {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .no_data {
    min-height: 520px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 960px) {
    .coupon_list .content {
      grid-template-columns: 1fr;
    }
  }
}
</style>
